/* eslint-disable no-mixed-operators */
/* eslint-disable linebreak-style */
import React, { useState, useEffect } from 'react'
import {
  Collapse, Navbar, NavbarToggler, Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap'
import { Link, NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import classnames from 'classnames'
import Logo from '../assests/images/logo.svg'
import profilePicture from '../assests/images/profile_pic.png'
// import profileIcon from '../assests/images/profile-icon.svg'
import logoutIcon from '../assests/images/logout-icon.svg'
import dashboardIcon from '../assests/images/dashboard-icon.svg'
import usersIcon from '../assests/images/users-icon.svg'
import contestIcon from '../assests/images/contest-icon.svg'
// import quizIcon from '../assests/images/quiz-icon.svg'
// import pdfIcon from '../assests/images/pdf-icon.png'
import settingsIcon from '../assests/images/game-settings-icon.svg'
import { logout } from '../actions/auth'
import { getProfile } from '../actions/account'
import { getUrl } from '../helper'

function NavBar (props) {
  const [isOpen, setIsOpen] = useState(false)
  const [profileDetails] = useState({})
  const toggle = () => setIsOpen(!isOpen)
  const dispatch = useDispatch()
  const url = getUrl()
  const token = useSelector(state => state.auth.token)
  const adminData = useSelector(state => state.auth.adminData)
  // const adminPermission = useSelector(state => state.auth.adminPermission)
  // const Auth = useSelector(state => state.auth.adminData && state.auth.adminData.eType)
  const history = props.history
  // const profile = useSelector(state => state.account.profile)
  // const previousProps = useRef({ profile }).current
  const permission = adminData.aPermissions
  useEffect(() => {
    dispatch(getProfile(token))
  }, [])

  // const userPath = history.location && (history.location.pathname.includes('/users/usermanagement'))

  // useEffect(() => {
  //   if (previousProps.profile !== profile) {
  //     if (profile) {
  //       setProfileDetails(profile)
  //     }
  //   }
  // }, [profile])

  function onLogout () {
    dispatch(logout(token))
  }
  return (
    <Navbar expand="lg" className='main-navbar' light>
      <div className="logobar d-flex justify-content-between align-items-center">
        <img src={Logo} alt="Logo" />
        <Nav navbar className="align-items-center">
          <UncontrolledDropdown nav inNavbar className="user-dropdown">
            <DropdownToggle nav caret>
              <img src={profileDetails && profileDetails.sProPic ? url + profileDetails.sProPic : profilePicture} alt="Profile Pic" />
              {profileDetails && profileDetails.sName}
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem onClick={onLogout}>
                <img src={logoutIcon} alt="Log Out" />
                <span className="d-inline-block align-middle">Log Out</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </div>
      <div className="menubar">
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav navbar>
            <NavItem className={classnames({ active: history.location && history.location.pathname === '/dashboard' })}>
              <NavLink to="/dashboard" className="nav-link">
                <img src={dashboardIcon} alt="Dashboard" />
                <span>Dashboard</span>
              </NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              {(!!permission?.length && (permission?.find(e => e?.eKey === 'USERS') && permission?.find(e => e?.eKey === 'USERS')?.eType !== 'N' ||                   
                                         permission?.find(e => e.eKey === 'ADMINUSER') && permission.find(e => e.eKey === 'ADMINUSER').eType !== 'N' ) || 
              (adminData?.eType === 'SUPER'))
                  ? (<DropdownToggle nav caret className={classnames({ active: history?.location && (history?.location?.pathname === '/users/usermanagement' || history?.location?.pathname?.includes('/users/usermanagement/view/')) })}>
                    <img src={usersIcon} alt="Users" />
                    <span>Users</span>
                  </DropdownToggle>)
                  : null
              }
              <DropdownMenu end>
                {(((!!permission?.length && permission?.find(e => e?.eKey === 'USERS') && permission.find(e => e?.eKey === 'USERS')?.eType !== 'N')) || adminData?.eType === 'SUPER')
                    ? (<DropdownItem tag={Link} className={classnames({ active: history?.location && (history?.location?.pathname === '/users/usermanagement' || history?.location?.pathname?.includes('/users/usermanagement/view/')) })} to="/users/usermanagement">User Management</DropdownItem>)
                    : null
                }
                {(((!!permission?.length && permission?.find(e => e?.eKey === 'ADMINUSER') && permission?.find(e => e.eKey === 'ADMINUSER')?.eType !== 'N')) || adminData?.eType === 'SUPER')
                    ? (<DropdownItem tag={Link} className={classnames({ active: history?.location && (history?.location?.pathname === '/users/admin-user' || history?.location?.pathname?.includes('/users/admin-user/add-admin-user')) })} to="/users/admin-user">Admin User</DropdownItem>)
                    : null
                }
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              {(!!permission?.length && (permission.find(e => e.eKey === 'CONTEST') && permission.find(e => e.eKey === 'CONTEST').eType !== 'N') || (adminData.eType === 'SUPER'))
                  ? (<DropdownToggle nav caret className={classnames({ active: history.location && (history.location.pathname === '/contest/contest-management') })}>
                    <img src={contestIcon} alt="Contest" />
                    <span>Contest</span>
                  </DropdownToggle>)
                  : null
              }
              <DropdownMenu right>
                {((!!permission?.length && permission.find(e => e.eKey === 'USERCONTEST') && permission.find(e => e.eKey === 'USERCONTEST').eType !== 'N') || adminData.eType === 'SUPER')
                  ? (<DropdownItem tag={Link} className={classnames({ active: history.location && (history.location.pathname === '/contest/user-contest') })} to="/contest/user-contest">User Contest</DropdownItem>)
                  : null
                }
                {((!!permission?.length && permission.find(e => e.eKey === 'USERCONTEST') && permission.find(e => e.eKey === 'USERCONTEST').eType !== 'N') || adminData.eType === 'SUPER')
                  ? (<DropdownItem tag={Link} className={classnames({ active: history.location && (history.location.pathname === '/contest/admin-contest') })} to="/contest/admin-contest">Admin Content</DropdownItem>)
                  : null
                }
              </DropdownMenu>
            </UncontrolledDropdown>
      
            <UncontrolledDropdown nav inNavbar>
              {(!!permission?.length && (permission?.find(e => e?.eKey === 'CMS') && permission?.find(e => e.eKey === 'CMS').eType !== 'N') || (adminData.eType === 'SUPER'))
                  ? (<DropdownToggle nav caret className={classnames({ active: history.location && (history.location.pathname === '/cms/cms-management' || history.location.pathname === '/cms/cms-management/addcms') })}>
                    <img src={settingsIcon} alt="Game Settings" />
                    <span>CMS</span>
                  </DropdownToggle>)
                  : null
              }
              <DropdownMenu right>
                {((!!permission.length && permission.find(e => e.eKey === 'CMS') && permission.find(e => e.eKey === 'CMS').eType !== 'N') || adminData.eType === 'SUPER')
                  ? (<DropdownItem tag={Link} to="/cms/cms-management" className={classnames({ active: history.location && (history.location.pathname === '/cms/cms-management' || history.location.pathname === '/cms/cms-management/addcms') })}>CMS Management</DropdownItem>)
                  : null
                }
                
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </div>
    </Navbar >
  )
}

NavBar.defaultProps = {
  history: {}
}

NavBar.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string
    }),
    push: PropTypes.func.isRequired
  })
}

export default NavBar
